import { gql } from '@apollo/client'

export const CREATE_USER_VEHICLE = gql`
    mutation create_user_vehicle($request: CreateUserVehicleRequest!) {
        create_user_vehicle(request: $request) {
            id
        }
    }
`

// $name: String!, $manufacturer: String!, $model: String!, $plate_id: Int!
